import { useState } from "react";

//import resources
import { FaSearch } from "react-icons/fa";

//import components
import SearchDropdown from '../header/SearchDropdown'

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

export default function Search () {

    const { t } = useTranslation();

    const [searchKey, setSearchKey] = useState('');

    return (
        <>
            <div className="h-full flex items-center relative">
                <input value={searchKey} onChange={(e)=>setSearchKey(e.target.value)} type="text" name="search" className="border border-gray-300 text-slate-900 text-sm rounded-3xl block w-full px-3 h-[50px] !outline-none placeholder:text-slate-500" placeholder={t('search_word')} />
                <button className="absolute rounded-3xl bg-[var(--orange)] px-10 h-[44px] right-0 me-0.5 top-0 mt-[6px] text-white">
                    <FaSearch className="color-white" />
                </button>
                {/* {
                    searchKey.length > 0 ? 
                        <SearchDropdown searchKey={searchKey} />
                    :
                    ''
                } */}
            </div>
            
            
        </>
    );
}